import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import { PodClass } from "../../../classes/Pod"
import { useStore } from "../../../contexts/store"
import { Tag } from "../../../shared/src/types/Content"

import Link from "../../Elements/Link"
import { Box, Chip } from "@mui/material"


const TagsPreview = ({pod}: {pod: PodClass}) => {
  const { t } = useTranslation()
  const { uiStore } = useStore()
  const tagColor = uiStore.getInteractionColor("tagging")
  const tagList = pod.getTags()
  const tags  = pod.getTagsOrder(tagList)

  function handleTagNavigation(tagId: string) {
    uiStore.shrinkAllTags()
    uiStore.setTagIsOpen(pod.podId, tagId, true)
  }

  const TagChip = observer(({order, tag}: {order: number, tag: Tag}) => {
    const wordSize = (order > 5) ? 21 : 15+order
    return (
      <Link onClick={() => handleTagNavigation(tag.tagId)} to={`/pod/${pod.podId}/tags/#${tag.tagId}`}>
        <Chip
          label={<Box sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            wordBreak: "break-all"
          }}>{`# ${tag.name}`}</Box>}
          sx={{
            backgroundColor: "white",
            borderColor: tagColor,
            color: tagColor,
            fontSize: `${wordSize}px`,
            fontWeight: 500,
            margin: "3px",
            padding: `${wordSize-5}px 0`,
            "&:hover": {
              backgroundColor: tagColor,
              color: "white"
            }
          }}
          variant={"outlined"}
        />
      </Link>
    )
  })


  return (
    <Box sx={{
      display: "flex",
      flexWrap: "wrap",
      gap: "1px",
      justifyContent: "center",
      margin: "15px 40px 30px 40px",
      wordBreak: "break-word"
    }}>
      {(Object.values(tags).length === 0) ?
        <Box sx={{
          display: "grid",
          fontStyle: "italic",
          fontWeight: 300,
          padding: "8px",
          marginTop: "15px"
        }}>
          {t('No Tags yet')}
        </Box>
        :
        <>
        {Object.values(tags).slice(0,15).map(item =>
          <TagChip key={item.tag.tagId} tag={item.tag} order={item.order} />
        )}
        {Object.values(tags).length > 15 &&
          <Box sx={{
            alignContent: "end",
            color: tagColor,
            fontSize: "20px"
          }}>...</Box>
        }
        </>
      }
    </Box>
  )
}

export default observer(TagsPreview)